import { api, ApiResponse } from './api'

/**
 * Fase D del roadmap (10. Sistema predictivo, 11. Sistema de
 * recomendaciones).
 */

export type ChannelKey = 'google' | 'facebook' | 'microsoft' | 'tiktok'

export interface ChannelProjection {
  channel: ChannelKey
  label: string
  daysWithSpendData: number
  daysWithLeadData: number
  dailyPace: { spend: number; leads: number; revenue: number }
  current: { spend: number; leads: number; revenue: number; roi: number }
  projection: { horizonDays: number; spend: number; leads: number; revenue: number; roi: number }
  recommendation: 'escalar' | 'mantener'
}

export interface CappingRecommendation {
  campaign: string
  capping: number
  leadsSoFar: number
  daysWithData: number
  dailyPace: number
  projectedDaysToReach: number | null
  avgValidationRate: number
  recommendation: 'subir_capping' | 'mantener_calidad_insuficiente' | 'mantener_con_margen'
}

export interface PredictionsData {
  channelProjections: ChannelProjection[]
  cappingRecommendations: CappingRecommendation[]
  meta: {
    projectionHorizonDays: number
    scaleRoiThresholdPct: number
    cappingHeadroomDays: number
    cappingMinValidationRate: number
  }
}

export const getPredictions = async (): Promise<ApiResponse<PredictionsData>> => {
  const response = await api.get<ApiResponse<PredictionsData>>('/dashboard/predictions')
  return response.data
}
